import { cn } from "@babybjorn/ui";
import { m } from "motion/react";
import type { FC } from "react";
import LazyFramer from "../../../LazyFramer";
import * as s from "./ModalOverlay.module.scss";

type ModalOverlayProps = {
	onClick?: () => void;
	hide?: boolean;
	className?: string;
};

const ModalOverlay: FC<ModalOverlayProps> = ({ onClick, hide, className }) => (
	<LazyFramer>
		<m.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 100 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.2 }}
			className={cn(s.overlay, className, { [s.hideBackdrop]: hide })}
			aria-hidden="true"
			{...(onClick ? { role: "button" } : {})}
			onClick={onClick}
		/>
	</LazyFramer>
);

export default ModalOverlay;
